import React, { useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const fieldSx = {
    "& .MuiOutlinedInput-root": {
        backgroundColor: "#f9fafb",
        borderRadius: "12px",
        "& fieldset": { borderColor: "#e5e7eb" },
        "&:hover fieldset": { borderColor: "#cbd5e1" },
        "&.Mui-focused": { backgroundColor: "#fff" },
        "&.Mui-focused fieldset": { borderColor: "#0b243d", borderWidth: "2px" },
    },
    "& .MuiInputLabel-root.Mui-focused": { color: "#0b243d" },
};

export default function ModalRecuperarSenha(props) {
    const [email, setEmail] = useState("");
    const [open, setOpen] = useState(false);


    const handleSubmit = async () => {
        setOpen(true);
        const { data } = await axios.post(
            `${process.env.REACT_APP_API_URL}/recuperarSenha`,
            { email }
        );
        console.log(data);
        if (data.status === 200) {
            setOpen(false);
            props.setOpenSnackbarSuccess(true);
            props.setMensagem(data.mensagem);
            props.setOpenRecuperarSenha(false);
        } else {
            setOpen(false);
            props.setMensagem(data.mensagem);
            props.setOpenSnackbarError(true);
        }
    };

    // Não permite fechar enquanto a requisição está em andamento
    const handleClose = () => {
        if (!open) props.setOpenRecuperarSenha(false);
    };

    return (
        <>
            <Dialog
                open={props.openRecuperarSenha}
                onClose={handleClose}
                fullWidth
                maxWidth="xs"
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: "24px",
                            overflow: "hidden",
                            m: 2,
                            width: "calc(100% - 32px)",
                            boxShadow: "0 30px 80px rgba(11, 36, 61, 0.35)",
                        },
                    },
                    backdrop: {
                        sx: { backgroundColor: "rgba(11, 36, 61, 0.6)", backdropFilter: "blur(4px)" },
                    },
                }}
            >
                {/* Topo com a identidade Clarea */}
                <Box
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                        background: "linear-gradient(135deg, #0b243d 0%, #12365a 100%)",
                        color: "#fff",
                        px: 3,
                        pt: 4,
                        pb: 6,
                        textAlign: "center",
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: -60,
                            right: -60,
                            width: 160,
                            height: 160,
                            borderRadius: "50%",
                            border: "28px solid #ffc845",
                            opacity: 0.18,
                        }}
                    />
                    <IconButton
                        onClick={handleClose}
                        disabled={open}
                        aria-label="Fechar"
                        sx={{
                            position: "absolute",
                            top: 12,
                            right: 12,
                            color: "rgba(255, 255, 255, 0.75)",
                            "&:hover": { color: "#fff", backgroundColor: "rgba(255, 255, 255, 0.1)" },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Box
                        sx={{
                            position: "relative",
                            width: 64,
                            height: 64,
                            mx: "auto",
                            borderRadius: "18px",
                            backgroundColor: "#ffc845",
                            color: "#0b243d",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 10px 24px rgba(255, 200, 69, 0.35)",
                        }}
                    >
                        <LockResetOutlinedIcon sx={{ fontSize: 34 }} />
                    </Box>
                    <Box sx={{ position: "relative", mt: 2, fontSize: "1.4rem", fontWeight: 800, letterSpacing: "-0.3px" }}>
                        Esqueceu sua senha?
                    </Box>
                    <Box sx={{ position: "relative", mt: 0.75, fontSize: "0.9rem", color: "rgba(255, 255, 255, 0.75)" }}>
                        Sem problemas, a gente te ajuda.
                    </Box>
                </Box>

                {/* Conteúdo (sobe sobre o topo, como na tela de login) */}
                <Box
                    component="form"
                    noValidate
                    onSubmit={(e) => {
                        e.preventDefault();
                        if (!open) handleSubmit();
                    }}
                    sx={{
                        position: "relative",
                        mt: -3,
                        backgroundColor: "#fff",
                        borderRadius: "24px 24px 0 0",
                        px: { xs: 3, sm: 4 },
                        pt: 3.5,
                        pb: 3,
                    }}
                >
                    <Box sx={{ mb: 2.5, fontSize: "0.95rem", lineHeight: 1.6, color: "#4b5563", textAlign: "center" }}>
                        Informe o e-mail cadastrado. Enviaremos as <b style={{ color: "#0b243d" }}>instruções para redefinir</b> sua senha.
                    </Box>

                    <TextField
                        autoFocus
                        disabled={open}
                        required
                        label="E-mail"
                        placeholder="seuemail@exemplo.com"
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        fullWidth
                        sx={fieldSx}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <EmailOutlinedIcon sx={{ fontSize: 20, color: "#9ca3af" }} />
                                    </InputAdornment>
                                ),
                            },
                        }}
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        disabled={open}
                        startIcon={open ? <CircularProgress size={18} sx={{ color: "#0b243d" }} /> : null}
                        sx={{
                            mt: 2.5,
                            py: 1.5,
                            fontSize: "1rem",
                            fontWeight: 700,
                            textTransform: "none",
                            backgroundColor: "#ffc845",
                            color: "#0b243d",
                            borderRadius: "12px",
                            boxShadow: "0 8px 24px rgba(255, 200, 69, 0.4)",
                            '&:hover': { backgroundColor: "#e9b53d", boxShadow: "0 10px 28px rgba(255, 200, 69, 0.5)" },
                            '&.Mui-disabled': { backgroundColor: "#ffe08a", color: "#0b243d" },
                        }}
                    >
                        {open ? "Enviando..." : "Enviar instruções"}
                    </Button>

                    <Button
                        fullWidth
                        disabled={open}
                        startIcon={<ArrowBackIcon sx={{ fontSize: "18px !important" }} />}
                        onClick={handleClose}
                        sx={{
                            mt: 1,
                            py: 1.1,
                            fontSize: "0.9rem",
                            fontWeight: 600,
                            textTransform: "none",
                            color: "#6b7280",
                            borderRadius: "12px",
                            "&:hover": { color: "#0b243d", backgroundColor: "rgba(11, 36, 61, 0.04)" },
                        }}
                    >
                        Voltar para o login
                    </Button>
                </Box>
            </Dialog>
        </>
    );
}
